export const hasVisibleText = (value) => String(value ?? "").trim().length > 0;

export const resolveTableKey = (row, index) => {
  const blockOrder = String(row.style_meta?.source_block_order || "");
  const tableIndex = String(row.style_meta?.table_index || "");
  if (blockOrder && tableIndex) {
    return `block-${blockOrder}-table-${tableIndex}`;
  }

  const structureRef = String(row.structure_ref || "");
  if (structureRef.includes("-row-")) {
    return structureRef.split("-row-")[0];
  }

  if (row.style_meta?.sheet) {
    return `sheet-${row.style_meta.sheet}`;
  }

  if (structureRef.startsWith("csv-row-")) {
    return "csv-table";
  }

  return `table-${index}`;
};

export const getTableCells = (row) => {
  const cells = Array.isArray(row.cells) ? row.cells.map((cell) => String(cell ?? "")) : [];
  if (cells.length > 0) {
    return cells;
  }

  const rowText = String(row.text ?? "");
  if (!hasVisibleText(rowText)) {
    return [];
  }

  if (rowText.includes("|")) {
    return rowText.split("|").map((cell) => cell.trim());
  }

  return [rowText];
};

export const buildDocumentRenderBlocks = (rows, options = {}) => {
  const { includeEmptyRows = false } = options;
  const orderedRows = [...rows]
    .filter((row) => {
      const normalized = String(row.text || "").toLowerCase().replace(/[^a-z0-9]+/g, "");
      if (["endofdocument", "enddocument", "endofdoc", "enddoc"].includes(normalized)) {
        return false;
      }

      if (includeEmptyRows) {
        return true;
      }

      if (row.row_kind === "table") {
        const cells = Array.isArray(row.cells) ? row.cells : [];
        const hasNonEmptyCell = cells.some((cell) => hasVisibleText(cell));
        return hasNonEmptyCell || hasVisibleText(row.text);
      }

      return hasVisibleText(row.text);
    })
    .sort((leftRow, rightRow) => (Number(leftRow.row_number) || 0) - (Number(rightRow.row_number) || 0));

  const blocks = [];
  let currentTableBlock = null;

  orderedRows.forEach((row, index) => {
    if (row.row_kind === "table") {
      const tableKey = resolveTableKey(row, index);
      if (!currentTableBlock || currentTableBlock.key !== tableKey) {
        currentTableBlock = { type: "table", key: tableKey, rows: [] };
        blocks.push(currentTableBlock);
      }
      currentTableBlock.rows.push(row);
      return;
    }

    currentTableBlock = null;
    blocks.push({ type: "paragraph", key: row.row_id || `row-${index}`, row });
  });

  return blocks;
};
